import React,{useState,useEffect} from 'react'
import { FiHome} from "react-icons/fi";
import './css/bread-crumbs.css'

function BreadCrumbs(props) {
    const [isHomePath,setIsHomePath] = useState(false);
    const [breadcrumbs,setBreadcrumbs] = useState([]);
    const [linkToPagenameMap] = useState({
      'statistics':'Statistics',
      'transaction':'Transaction List',
      'cases':'Cases',
      'preference':'Preference',
      'view':'Transaction View',
      'cases-group-by-week':'cases weekly'

    });
    useEffect(() => {
      setBreadcrumbs([]);
      let crumbs = window.location.pathname.split('/');
      for(let i=1;i<crumbs.length;i++){
        //statistics considered as home path
        if(crumbs.length === 2 && crumbs[i] === 'statistics'){
          setIsHomePath(true);
        }
        let crumb = {};
        crumb['name'] = linkToPagenameMap[crumbs[i]] ? linkToPagenameMap[crumbs[i]] : crumbs[i];
        crumb['link'] = crumbs.slice(0, i+1).join('/');
        if(crumbs[i] !== 'statistics')
          setBreadcrumbs(prevState => [...prevState, crumb]);
      }
      if(props.hasOwnProperty('extraCrumbs')){
        for(let i=1;i<props.extraCrumbs.length;i++){
          let crumb = {};
          crumb['name'] = props.extraCrumbs[i].name;
          crumb['link'] = props.extraCrumbs[i].link;  
          setBreadcrumbs(prevState => [...prevState, crumb]);
        }
      }
    //Disabling the ES-lint dependency warning, This hook is to implement componentdidmount 
    // eslint-disable-next-line react-hooks/exhaustive-deps 
    },[]);
    return (
        <>
        <ul className="breadcrumbs">
          <li className={isHomePath ? "first active last" :"first"}><a href="/statistics" className="icon"><FiHome /></a></li>
          {
            breadcrumbs.map((crumb,index,arr)=>(
               <li key={index} className={ arr.length === index+1 && "last active"}><a href={crumb.link}>{crumb.name}</a></li> 
            ))
          }
          {/* <li><a href="#">Second Level Interior Page</a></li>
          <li><a href="#">Third Level Interior Page</a></li>
          <li class="last active"><a href="#">Fourth Level Interior Page</a></li> */}
        </ul>
      </>
    )
}

export default BreadCrumbs
